/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EventRewardResponse } from './EventRewardResponse';
export type PromotionalEventResponse = {
    /**
     * Event ID
     */
    id: string;
    /**
     * Event name
     */
    name: string;
    /**
     * Event description
     */
    description?: string | null;
    /**
     * 1=DRAFT, 2=ACTIVE, 3=ENDED, 4=ARCHIVED
     */
    status: PromotionalEventResponse.status;
    /**
     * Event banner image URL
     */
    bannerUrl?: string | null;
    /**
     * Event start time (null until activated)
     */
    startedAt?: string | null;
    /**
     * Event end time
     */
    endsAt: string;
    /**
     * Admin who created the event
     */
    createdBy?: string | null;
    createdAt: string;
    updatedAt: string;
    /**
     * Fixed whale points for daily login
     */
    dailyLoginWp: number;
    /**
     * Percentage in basis points for deposits (100 = 1%)
     */
    depositWp: number;
    /**
     * Percentage in basis points for case opening (200 = 2%)
     */
    caseOpenWp: number;
    /**
     * Fixed whale points for giveaway join
     */
    giveawayJoinWp: number;
    /**
     * Multiplier for featured cases (e.g., 4.0 = 4x)
     */
    featuredMultiplier: number;
    /**
     * Event rewards configuration
     */
    rewards?: Array<EventRewardResponse>;
    /**
     * Number of participants
     */
    participantCount?: number;
};
export namespace PromotionalEventResponse {
    /**
     * 1=DRAFT, 2=ACTIVE, 3=ENDED, 4=ARCHIVED
     */
    export enum status {
        '_1' = 1,
        '_2' = 2,
        '_3' = 3,
        '_4' = 4,
    }
}

